import { Illustration } from '@orientaction/types';

export function getIllustrationUrl(
  illustration: Illustration | number | null | undefined,
): string | undefined {
  if (illustration && typeof illustration === 'object' && 'url' in illustration) {
    return illustration.url;
  }
  return undefined;
}

export const getRestartedResultId = (response: {
  idResult?: number;
  res?: { id?: number };
  id?: number;
}): number | undefined => {
  const id = response?.idResult ?? response?.res?.id ?? response?.id;
  const parsed = Number(id);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};
